<template>
    <div class="container">
        <app-testament-buttons v-if="this.$store.getters.getCurrentPage == 'home' || this.$store.getters.getCurrentPage == 'jesus'"  :oldTSelected="this.$store.getters.getOldTSelected"></app-testament-buttons>
        <div class="row modal-btns">
            <div class="col-6 col-md-6">
                <button 
                    class="btn btn-default" 
                    @click.prevent="changeBibleVersion" 
                    >Toogle - {{ this.$store.getters.getEsvState ? 'KJV' : 'ESV' }}</button>
            </div>
            <div class="col-6 col-md-6">
                <button 
                    class="btn btn-default"
                    :class="{active: this.$store.getters.getSearchByState == 'chapter'}"
                    @click.prevent="searchBy('chapter')" 
                    >View by Chapter</button>
            </div>
            <div class="col-6 col-md-6">
                <button 
                    class="btn btn-default"
                    :class="{active: this.$store.getters.getSearchByState == 'verse'}"
                    @click.prevent="searchBy('verse')" 
                    >View by Verse</button>
            </div>
            <div class="col-6 col-md-6">
                <button 
                    class="btn btn-default"
                    :class="{active: this.$store.getters.getSearchByState == 'range'}"
                    @click.prevent="searchBy('range')" 
                    >View by Range</button>
            </div>
        </div>
    </div>
</template>

<script>
    import TestamentButtons from '../components/TestamentButtons.vue';

    export default {
        methods: {
            changeBibleVersion() {
                this.$store.dispatch('setBibleVersion');
            },
            searchBy(target) {
                this.$store.dispatch('setSearchBy', target);
            }
        },
        components: {
            appTestamentButtons: TestamentButtons
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ModalButtons.vue